import { mutationTypes, actionTypes } from '@/types';

export default {
	state: {
		galleryIsOpened: false,
		galleryImages: null,
	},
	getters: {
		getGalleryIsOpened(state) {
			return state.galleryIsOpened;
		},
		getGalleryImages(state) {
			return state.galleryImages;
		},
	},
	mutations: {
		[mutationTypes.setGalleryImages](state, mediaObjects) {
			state.galleryImages = mediaObjects;
		},
		[mutationTypes.setGalleryIsOpened](state, galleryIsOpened) {
			state.galleryIsOpened = galleryIsOpened;
		},
	},
	actions: {
		[actionTypes.openGallery]({ commit }, mediaObjects) {
			commit(mutationTypes.setGalleryImages, mediaObjects);
			commit(mutationTypes.setGalleryIsOpened, true);
		},
		[actionTypes.closeGallery]({ commit }) {
			commit(mutationTypes.setGalleryImages, null);
			commit(mutationTypes.setGalleryIsOpened, false);
		},
	},
};
